<template>
  <div class="activityPageList">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>内容</el-breadcrumb-item>
      <el-breadcrumb-item>自定义活动页</el-breadcrumb-item>
      <el-breadcrumb-item>活动页列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="search-container">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="创建日期">
          <el-date-picker
            v-model="searchForm.dataTime"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy/MM/dd"
            @change="onDateChange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="关键字" class="keyword">
          <!-- 后端两个标题一起搜(ActivityPageLogic::cmsList)。提示语要写清是哪两个，
               否则运营拿自己起的活动标题搜不到，会以为页面被删了 -->
          <el-input v-model="searchForm.search_keyword" placeholder="活动标题 / 页面标题"></el-input>
        </el-form-item>
      </el-form>
      <div class="btn mg-t-10">
        <el-button type="primary" size="medium" @click="search">查询</el-button>
        <el-button size="medium" @click="clearForm">清空</el-button>
      </div>
    </div>

    <div class="dataTable">
      <div class="tabs flex">
        <p v-for="(item, index) in tabs" :key="index" :class="{ on: currentTab === index }" @click="switchTab(index)">
          {{ item }}
        </p>
      </div>
      <div class="text-right mg-b-20">
        <el-button type="primary" @click="$router.push({ name: 'activityPageEdit' })">新建活动页</el-button>
      </div>

      <el-table :data="tableData.data" border tooltip-effect="dark" style="width: 100%">
        <!--
          活动标题当主列、页面标题降为副行：线上多个页面的**展示标题都叫「博雅生命」**，
          只列 title 的话这一列全是一样的字，运营点进去才知道是哪个。
          活动标题为空就退回显示页面标题（旧数据都没这个值），并且不再重复画一遍副行。
        -->
        <el-table-column label="活动标题" :align="'left'" show-overflow-tooltip min-width="200">
          <template slot-scope="scope">
            <div>{{ scope.row.activity_title || scope.row.title }}</div>
            <div v-if="scope.row.activity_title" class="font-12 color-999">页面标题：{{ scope.row.title }}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" :align="'center'" width="140">
          <template slot-scope="scope">
            <!--
              status 是运营手动的上下架开关；is_online 才是"此刻小程序打开它能不能看到"
              —— 定时上架的页面在窗口外就是 status=1 但 is_online=2。两个都得显示，
              不然运营会以为上架了却打不开。
            -->
            <el-tag :type="scope.row.status == 1 ? 'success' : 'info'" size="mini">
              {{ scope.row.status == 1 ? '上架' : '未上架' }}
            </el-tag>
            <div v-if="scope.row.status == 1 && scope.row.is_online != 1" class="font-12 color-999">
              不在生效时间内
            </div>
          </template>
        </el-table-column>
        <el-table-column label="上架设置" :align="'center'" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.shelf_type == 1">立即上架</span>
            <span v-else class="font-12">
              {{ scope.row.shelf_start_time }}<br />至 {{ scope.row.shelf_end_time }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" :align="'center'" width="80"></el-table-column>
        <el-table-column prop="create_by" label="创建人" :align="'center'" width="120"></el-table-column>
        <el-table-column prop="create_time" label="创建时间" :align="'center'" width="170" sortable></el-table-column>
        <el-table-column label="操作" :align="'center'" width="240" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status == 1" type="text" @click="changeStatus(scope.row, 2)">下架</el-button>
            <el-button v-else type="text" @click="changeStatus(scope.row, 1)">上架</el-button>
            <el-button type="text" @click="toEdit(scope.row)">编辑</el-button>
            <el-button type="text" @click="showQrcode(scope.row)">小程序码</el-button>
            <el-button type="text" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        :total="tableData.total"
        :per_page="tableData.per_page"
        :current_page="tableData.current_page"
        @handleCurrentChange="onPage"
        @handleSizeChange="onSize"
      />
    </div>

    <el-dialog title="小程序码" :visible.sync="qrcodeVisible" width="360px">
      <div class="text-center">
        <img v-if="qrcode" :src="qrcode" class="qrcode" />
        <p class="font-12 color-999 mg-t-10">右键另存为即可下载。扫码直接打开这个活动页。</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import pagination from '../../../components/pagination.vue'

  export default {
    name: 'activityPageList',
    components: { pagination },
    data() {
      return {
        tabs: ['上架', '未上架'],
        currentTab: 0,
        searchForm: {
          dataTime: '',
          search_keyword: '',
          search_start_time: '',
          search_end_time: '',
          search_status: 1
        },
        tableData: { data: [], per_page: 10, current_page: 1, total: 0 },
        qrcodeVisible: false,
        qrcode: ''
      }
    },
    created() {
      this.getList()
    },
    methods: {
      getList() {
        this.$api.activityPage
          .getList({
            search_status: this.searchForm.search_status,
            search_keyword: this.searchForm.search_keyword,
            search_start_time: this.searchForm.search_start_time,
            search_end_time: this.searchForm.search_end_time,
            page_size: this.tableData.per_page,
            page_index: this.tableData.current_page
          })
          .then(res => {
            this.tableData = res
          })
          .catch(err => this.$message.error(err))
      },
      search() {
        this.tableData.current_page = 1
        this.getList()
      },
      onDateChange(v) {
        this.searchForm.search_start_time = v ? v[0] + ' 00:00:00' : ''
        this.searchForm.search_end_time = v ? v[1] + ' 23:59:59' : ''
      },
      clearForm() {
        this.searchForm.dataTime = ''
        this.searchForm.search_keyword = ''
        this.searchForm.search_start_time = ''
        this.searchForm.search_end_time = ''
        this.search()
      },
      switchTab(index) {
        this.currentTab = index
        this.searchForm.search_status = index + 1
        this.search()
      },
      toEdit(row) {
        // 只带 uuid，详情由编辑页自己拉 —— 不学 bannerList 那样把整行塞 query，
        // 那样组件和图这种嵌套结构根本塞不进 URL。
        this.$router.push({ name: 'activityPageEdit', query: { uuid: row.uuid } })
      },
      changeStatus(row, status) {
        this.$api.activityPage
          .updateStatus(row.uuid, { status })
          .then(() => {
            this.$message.success(status === 1 ? '上架成功' : '下架成功')
            this.getList()
          })
          .catch(err => this.$message.error(err))
      },
      remove(row) {
        this.$confirm('删除后无法恢复，确定删除吗？', '删除确认', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$api.activityPage
              .delete(row.uuid)
              .then(() => {
                this.$message.success('删除成功！')
                this.getList()
              })
              .catch(err => this.$message.error(err))
          })
          .catch(() => {})
      },
      showQrcode(row) {
        this.qrcode = ''
        this.qrcodeVisible = true
        this.$api.activityPage
          .getQrcode(row.uuid)
          .then(res => {
            this.qrcode = res.qrcode
          })
          .catch(err => {
            this.qrcodeVisible = false
            this.$message.error(err)
          })
      },
      onPage(v) {
        this.tableData.current_page = v
        this.getList()
      },
      onSize(v) {
        this.tableData.per_page = v
        this.getList()
      }
    }
  }
</script>

<style scoped>
  .search-container {
    padding: 20px;
    background: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    font-size: 12px !important;
  }
  .dataTable {
    position: relative;
  }
  .dataTable .tabs {
    position: absolute;
    top: 35px;
    left: 20px;
  }
  .dataTable .tabs p {
    padding: 10px 20px;
    position: relative;
    cursor: pointer;
  }
  .dataTable .tabs p:after {
    content: '';
    width: 100%;
    height: 2px;
    background: none;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .dataTable .tabs p.on:after {
    background: #409eff;
  }
  .qrcode {
    width: 240px;
    height: 240px;
  }
  >>> .el-button--text {
    padding: 5px 0px;
  }
  >>> .el-button--text span {
    font-size: 12px;
  }
</style>
